import React from "react";

export default function ManualQuoteError({ onBack, message = '' }) {
    return (
        <div className="fc-empty-wrapper">
            <div className="fc-empty-card">
                <h1 className="fc-empty-title">
                    {message}
                </h1>

                <p className="fc-empty-text">
                    Please get in touch with your agent at{" "}
                    <strong>800-716-7608</strong> to find out about the shipment details.
                </p>

                <button className="primaryBtn fc-empty-btn" onClick={onBack}>
                    Go to Saved Quotes
                </button>
            </div>
        </div>
    );
}
